import React from "react";
import "./contacts.css";
import { AiTwotoneMail } from "react-icons/ai";

import { FcPhone } from "react-icons/fc";

const Contacts = () => {
  function sendEmail() {
    window.location.href = "mailto:srsourabh06@gmail.com";
  }
  return (
    <section id="contacts">
      <h2>
        Contact Me <span className="dot">.</span>{" "}
      </h2>

      <div className="container experience__container">
        <span
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <lord-icon
            src="https://cdn.lordicon.com/fmasbomy.json"
            trigger="loop"
            delay="2000"
            stroke="light"
            colors="primary:#7f00e0,secondary:#aadcec,tertiary:#ffc738"
            style={{ width: "250px", height: "250px" }}
          ></lord-icon>
        </span>

        <span
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            marginTop: "20px",
            justifyContent: "center",
          }}
        >
          <AiTwotoneMail />
          <h5>srsourabh06@gmail.com</h5>
          <br />
          <FcPhone />
          <h5>+91 8889470449</h5>
          <br />
          <button
            onClick={sendEmail}
            className="btn btn-primary"
            style={{ marginTop: "10px" }}
          >
            Hire Me!
          </button>
        </span>

        <span style={{ minHeight: "100px" }}></span>
      </div>
    </section>
  );
};

export default Contacts;
